import { GridColDef } from '@mui/x-data-grid';
import moment from 'moment';
import React from 'react';

import DataGrid from '#app/Component/DataGrid';
import { transformObjectToDataGridRowsArray } from '#app/Util/DataGridDataTransformer';
import OrderClientEntryPoints from '#app/entrypoints/orderClient';
import { useCollectionPaginated } from '#app/hooks/useCollectionPaginated';
import { CarrierTranslation } from '#app/typings/carrier';
import { Channel, ChannelTranslations } from '#app/typings/channel';
import { OrderClientState, OrderClientStateTranslation, OrderClientUserManager } from '#app/typings/orderClient';

const OrderList: React.FC = () => {
  const {
    data: orderClients,
    loading,
    pagination,
    setPagination,
    totalItems,
    sorting,
    setSorting,
  } = useCollectionPaginated<OrderClientUserManager>(
    OrderClientEntryPoints.getCollectionPreparer,
    { sorting: { sortName: 'confirmedAt', sortDirection: 'asc' } },
    {},
    { refreshInterval: 20000 },
  );

  const columns: GridColDef[] = [
    {
      field: 'number',
      headerName: 'Référence',
      flex: 1,
      sortable: false,
    },
    {
      field: 'email',
      headerName: 'Email',
      valueGetter: (_, row: OrderClientUserManager) => row.client?.email,
      flex: 1,
      sortable: false,
    },
    {
      field: 'channel',
      headerName: 'Canal',
      valueGetter: (value: Channel) => ChannelTranslations[value],
      flex: 1,
    },
    {
      field: 'carrier',
      headerName: 'Transporteur',
      valueGetter: (_, row: OrderClientUserManager) => CarrierTranslation[row.orderClientCarrier?.carrier?.code],
      flex: 1,
    },
    {
      field: 'confirmedAt',
      headerName: 'Date',
      valueFormatter: (value) => moment(value).format('DD/MM/YYYY hh:mm'),
      flex: 1,
    },
    {
      field: 'orderClientState',
      headerName: 'Etat',
      valueGetter: (value: OrderClientState) =>
        value === OrderClientState.CONFIRMED ? 'En attente de préparation' : OrderClientStateTranslation[value],
      flex: 1,
    },
  ];

  return (
    <DataGrid
      loading={loading}
      rows={transformObjectToDataGridRowsArray<OrderClientUserManager>(orderClients)}
      columns={columns}
      rowCount={totalItems}
      setSorting={setSorting}
      setPagination={setPagination}
      pagination={pagination}
      sorting={sorting}
    />
  );
};

export default OrderList;
